import { useEffect, useRef } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Separator, Button, useDialog } from '@albo-ui/core'
import { CustomerFeaturesProps } from "./types";
import { useFeaturesTable } from "./hooks/useFeaturesTable";
import { useFeaturesAdmin } from "./hooks/useFeaturesAdmin";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { paginationComponentOptions } from "../../../util/i18n-es";
import SavingsIcon from '@mui/icons-material/Savings';
import { FeatureAdmin } from '../../modals/feature-admin/FeatureAdmin'
import { Box, IconButton, Tab, Tabs, TextField } from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";

export const FeatureList = ({ changeAlert, changeLoader, sectionData }: CustomerFeaturesProps) => {
    const onOpenUpdateFeatures = () => {
        dialogProps.openDialog()
    }
    const inputAdd = useRef(null);
    const inputRemove = useRef(null);
    const { theme } = useThemeProvider();
    const { columns, data, loading: loadingTable,page, perPage, totalRows, filters, reset, featureSearch, changeValueSearch, saveData, handlePageChange, handlePerRowsChange } = useFeaturesTable(changeAlert)
    const { loading: loadingUpdate, listCustomers, title, tabs, tabActive, changeTab, onSelectFile, updateFeature } = useFeaturesAdmin(changeAlert, onOpenUpdateFeatures)
    const dialogProps = useDialog()

    const addFile = (type) => {
        document.getElementById(`file-${type}`).click();
    }
    const onUpdateCustomers = async (data: any) => {
        dialogProps.onClose()
        cleanInputs()
        updateFeature(data)
    }
    const onCloseDialogCoupons = () => {
        dialogProps.onClose()
        cleanInputs()
    }
    const cleanInputs = () => {
        inputAdd.current.value = null;
        inputRemove.current.value = null;
    }
    
    function findActiveTab(item) { 
        return item.name === tabActive;
    }
    

    useEffect(() => {
       saveData(sectionData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    
    return (
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee}}> 
            <FlexGrid container fullWidth justify="space-between">
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <SavingsIcon sx={{ marginRight: 1 }}/> Administrador de Beneficios
					</Typography>
                </FlexGrid>
                <FlexGrid item>
                    <FlexGrid container spacing={2}>
                        <Button onClick={addFile.bind(this, "add")} buttonType='secondary' size='normal' style={{width: 110}}>
                            <input ref={inputAdd} type="file" accept="text/csv" style={{display: 'none'}} id="file-add" onChange={onSelectFile.bind(this, "add")}/>
                            Habilitar</Button>
                        <Button onClick={addFile.bind(this, "remove")} size='normal' buttonType='secondary' style={{width: 115}}>
                            <input ref={inputRemove} type="file" accept="text/csv" style={{display: 'none'}} id="file-remove" onChange={onSelectFile.bind(this, "remove")}/>
                            Deshabilitar</Button>
                    </FlexGrid>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: 520, paddingTop: 15, paddingBottom: 25}}>
                <TextField
                    label={"Nombre"} value={filters["feature_name"] || ""} color="secondary" size="small" fullWidth
                    onChange={changeValueSearch.bind(this, "feature_name")}
                    InputProps={{endAdornment: (<IconButton onClick={featureSearch.bind(this)} ><Search/></IconButton>)}}
                />
                <TextField
                    label={"UUID"} value={filters["uuid"] || ""} color="secondary" size="small" fullWidth
                    onChange={changeValueSearch.bind(this, "uuid")}
                    InputProps={{endAdornment: (<IconButton onClick={featureSearch.bind(this)} ><Search/></IconButton>)}}
                />
                <IconButton onClick={reset.bind(this)} sx={{padding: "0 !important"}} ><Refresh sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }}/></IconButton>
            </FlexGrid>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
              <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' >
                {tabs.map((item, index) => {
                  return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 18}} />
                })}
              </Tabs>
            </Box>

            { data?.length === 0 && <Separator orientation="horizontal" style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container style={{margin: '25px 0' }} direction="column">
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            pagination
                            paginationServer
                            paginationDefaultPage={page}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationComponentOptions={paginationComponentOptions}
                        />
                }
            </FlexGrid>
            <FeatureAdmin 
                title={title} 
                open={dialogProps.open} 
                onClose={onCloseDialogCoupons} 
                onConfirm={onUpdateCustomers.bind(this)} 
                changeAlert={changeAlert} 
                featureList={data}
                listCustomers={listCustomers}
            />
        </Card>
    )
}

